import { globalKeyDownReactiveMap } from '../rx/reactive_map/useKeyDownReactiveMap'
import { Engine } from './core/engine/Engine.type'
import { setEngineKeyDownReactiveMap } from './three/fn/getSetEngineKeyDownReactiveMap'

export default function bindEngineToKeyboard(
  engine: Engine,
) {
  setEngineKeyDownReactiveMap(engine, globalKeyDownReactiveMap)
}
